import { FlightsErrorReporter } from "../utils/report-error.js";
import { useCallback, useEffect } from "react";
import useContextName from "./useContextName.js";
import useGlobalContext from "./useGlobalContext.js";
import { grumble, squeak, warning } from "../utils/flog.js";
export default function useEvents() {
    const contextName = useContextName();
    const { requestId, etStateBlob } = useGlobalContext();
    useEffect(() => {
        FlightsErrorReporter.getInstance().resetErrorReporter(contextName, requestId, etStateBlob);
    }, [contextName, requestId, etStateBlob]);
    const jsError = useCallback((error) => {
        FlightsErrorReporter.getInstance().sendError(error);
    }, []);
    return { grumble, squeak, warning, jsError };
}
